import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScheduleEffects } from './+state/schedule/schedule.effects';
import { StoreModule } from '@ngrx/store';
import * as fromSchedule from './+state/schedule/schedule.reducer';
import { EffectsModule } from '@ngrx/effects';
import * as fromReportSchedule from './+state/report-schedules/report-schedules.reducer';
import { ReportSchedulesEffects } from './+state/report-schedules/report-schedules.effects';
import * as fromEmailSearch from './+state/email-search/email-search.reducer';
import { EmailSearchEffects } from './+state/email-search/email-search.effects';
import { EmailSearchFacadeService } from './+state/email-search/email-search.facade.service';
import {
  EmailSearchFacade,
  SchedulesFacade,
  ScheduleModalFacade,
  ScheduleOwnerFacade,
  ScheduleSlackFacade,
  ScheduleSubscriptionFacade,
} from '@mode/shared/schedules/contract';
import { ReportSchedulesFacade } from '@mode/shared/schedules/contract';
import { ReportSchedulesFacadeService } from './+state/report-schedules.facade.service';
import { SchedulesFacadeService } from './schedules.facade.service';
import { ScheduleModalFacadeService } from './schedule-modal.facade.service';
import { ScheduleOwnerFacadeService } from './schedule-owner.facade.service';
import { ScheduleSlackFacadeService } from './schedule-slack.facade.service';
import { ScheduleSubscriptionFacadeService } from './schedule-subscriptions.facade.service';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { AlgoliaDomainModule } from '@mode/algolia/domain';

@NgModule({
  imports: [
    AlgoliaDomainModule,
    CommonModule,
    StoreModule.forFeature(fromSchedule.scheduleFeatureKey, fromSchedule.reducer),
    StoreModule.forFeature(fromReportSchedule.reportSchedulesFeatureKey, fromReportSchedule.reducer),
    StoreModule.forFeature(fromEmailSearch.EMAIL_SUBSCRIBER_FEATURE_KEY, fromEmailSearch.emailSearchReducer),
    EffectsModule.forFeature([ScheduleEffects, ReportSchedulesEffects, EmailSearchEffects]),
  ],
  providers: [
    { provide: SchedulesFacade, useClass: SchedulesFacadeService },
    { provide: ScheduleModalFacade, useClass: ScheduleModalFacadeService },
    { provide: ScheduleOwnerFacade, useClass: ScheduleOwnerFacadeService },
    { provide: ScheduleSlackFacade, useClass: ScheduleSlackFacadeService },
    { provide: ScheduleSubscriptionFacade, useClass: ScheduleSubscriptionFacadeService },
    { provide: EmailSearchFacade, useClass: EmailSearchFacadeService },
    { provide: ReportSchedulesFacade, useClass: ReportSchedulesFacadeService },
  ],
})
export class SharedSchedulesDomainModule {}
